import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from 'app/modules/translate.module';

@Component({
    selector: 'mon-password-reset',
    templateUrl: './password-reset.component.html',
    imports: [CommonModule, TranslateModule, FormsModule],
})
export class PasswordResetComponent {
    email = '';
    sendPasswordResetRequest (): void {}
}
